export const argumentsFlaws = [
  {
    slug: 'ARGUMENT_DEFINITION_ISSUE',
    meaning: 'Action arguments are missing, unsupported, incomplete, or incorrectly defined.',
    detectionModes: ['classifier', 'code'],
    severity: 'medium',
    fixCategories: ['actionArguments'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        requestShape: {
          type: 'string'
        },
        providerRejectionObserved: {
          type: 'boolean',
          const: true
        },
        providerStatus: {
          type: 'integer',
          minimum: 400,
          maximum: 499
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        requestShape: {
          type: 'string'
        },
        providerDocumentationUrl: {
          type: 'string'
        },
        documentedMismatch: {
          type: 'string'
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        missingStructure: {
          type: 'string'
        },
        providerDocumentationUrl: {
          type: 'string'
        },
        expectedFields: {
          type: 'stringArray',
          minItems: 1
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        missingStructure: {
          type: 'string'
        },
        siblingFields: {
          type: 'stringArray',
          minItems: 1
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        contractViolation: {
          type: 'string'
        }
      }
    ],
    verificationRecipe: ['action runs with the argument removed/replaced; request matches the provider contract.', 'object decomposed into child arguments; enum list classified; run observed.', 'one key per semantic, canonical type, coherent required/defaults; payload assembled and run observed.'],
    legacyCodes: [],
    evidenceRelations: [],
    codeEvidenceAlternatives: [
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        contractViolation: {
          type: 'string'
        }
      }
    ]
  },
  {
    slug: 'LOOKUP_ISSUE',
    meaning: 'An argument lookup is missing or cannot supply valid labels and values.',
    detectionModes: ['classifier', 'code'],
    severity: 'medium',
    fixCategories: ['lookups', 'responseSchema'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        argumentKey: {
          type: 'string'
        },
        lookupConfigured: {
          type: 'boolean',
          const: false
        },
        sourceActionId: {
          type: 'string'
        },
        sourceIsSameApp: {
          type: 'boolean',
          const: true
        },
        sourceIsReadMany: {
          type: 'boolean',
          const: true
        },
        sourceIsTargetAction: {
          type: 'boolean',
          const: false
        },
        sourceValueField: {
          type: 'string'
        },
        identifierMatchConfirmed: {
          type: 'boolean',
          const: true
        }
      },
      {
        argumentKey: {
          type: 'string'
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        lookupFailedToPopulate: {
          type: 'boolean',
          const: true
        }
      }
    ],
    verificationRecipe: ['`list.type=lookup` wired to a real read action with label/value mapped; lookup resolves options in a run.', 'Configure valid lookup or fixed options.', 'Observe populated options in a read-only lookup run.', 'If the source action needs changes, create separate work or require human review.'],
    legacyCodes: ['LOOKUP_SOURCE_MISSING', 'LOOKUP_SOURCE_ACTION_NOT_FOUND', 'LOOKUP_SOURCE_PAYLOAD_NOT_MAPPABLE', 'LOOKUP_SOURCE_CONTRACT_CONFLICT'],
    evidenceRelations: [],
    codeEvidenceAlternatives: [
      {
        argumentKey: {
          type: 'string'
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        lookupFailedToPopulate: {
          type: 'boolean',
          const: true
        }
      }
    ]
  }
];
